import * as routes from "./route";
import { clone } from "../common/js/tool";
import store from "../store";

export const moduleList = [
    {
        title: '数据看板',
        key: 'dashboard',
        icon: 'pie-chart'
    },
    {
        title: '横幅管理',
        key: 'banner',
        icon: 'profile'
    },
    {
        title: '审批列表',
        key: 'approval',
        icon: 'edit',
        routers: ['approval', 'approvalDetail']
    },
    {
        title: '服务案例',
        key: 'case',
        routers: ['serviceCase'],
        icon: 'profile'
    },
    {
        title: '文章管理',
        key: 'article',
        icon: 'menu'
    },
    {
        title: '场馆管理',
        key: 'venue',
        icon: 'bank'
    },
    {
        title: '酒店管理',
        key: 'hotel',
        icon: 'home'
    },
    {
        title: '礼品管理',
        key: 'gift',
        icon: 'gift'
    },
    {
        title: '角色权限',
        key: 'setting',
        icon: 'setting',
        children: [
            { title: '角色管理', key: 'setting-role', path: '/role', routers: ['role'] },
            { title: '权限管理', key: 'setting-admin', path: '/admin', routers: ['admin'] },
        ]
    },
];


export const getModuleIds = function (modules) {
    let ids = modules || [];
    if (typeof modules === 'string') {
        ids = modules.split(",");
    }
    return ids;
}

export const getModuleNames = function (modules) {
    const ids = getModuleIds(modules);
    const names = [];
    moduleList.forEach(m => {
        if(ids.includes(m.key)) {
            names.push(m.title);
        } else if(m.children) {
            m.children.forEach(c => {
                if(ids.includes(c.key)) {
                    names.push(c.title);
                }
            })
        }
    });
    return names.join("、");
}

export const getModuleRouters = function (m) {
    const routers = [], entity = [];
    if (m.routers) {
        m.routers.forEach(item => {
            const r = routes[item];
            if(r) {
                if (r.entity) {
                    entity.push(r.entity);
                } else {
                    routers.push(clone(r));
                }
            }
        });
    } else if(routes[m.key]) {
        const r  = routes[m.key];
        if(r) {
            if (r.entity) {
                entity.push(r.entity);
            } else {
                routers.push(clone(r));
            }
        }
    }
    return [routers, entity];
}

const setRouters = function (m, routers, entity) {
    const [rs, es] = getModuleRouters(m);
    routers.push(...rs);
    entity.push(...es);
}

const getModuleMenu = function (m) {
    const menu = {
        title: m.title,
        path: m.path || `/${m.key}`,
    }
    if(m.icon) {
        menu.icon = m.icon;
    }
    return menu;
}

export const getUserRouterMenus = function (user) {
    const modules = user && user.role ? user.role.modules : "";
    const ids = getModuleIds(modules);
    const routers = [], menus = [], entity = [];
    moduleList.forEach(m => {
        const menu = getModuleMenu(m);
        if (m.children) {
            if (ids.includes(m.key)) {
                m.children.forEach(c => setRouters(c, routers, entity));
                menu.children = m.children.map(c => getModuleMenu(c));
                menus.push(menu);
            } else {
                const children = [];
                m.children.forEach(c => {
                    if (ids.includes(c.key)) {
                        setRouters(c, routers, entity);
                        children.push(getModuleMenu(c));
                    }
                });
                if (children.length > 0) {
                    menu.children = children;
                    menus.push(menu);
                }
            }
        } else {
            if (ids.includes(m.key)) {
                setRouters(m, routers, entity);
                menus.push(menu);
            }
        }
    });

    // 默认将menu第一个作为默认路由
    const path = menus[0].path;
    store.commit("setMenus", menus);
    store.commit("setDefaultPath", path);
    const homeRoute = clone(routes.homeRoute);
    const entityRoute = clone(routes.entityRoute);
    homeRoute.children = [ ...routers ];
    homeRoute.redirect = { path };
    if (entity.length > 0) {
        entityRoute.meta.modules = [...entity];
        homeRoute.children.push(entityRoute);
    }
    return [[homeRoute], path];
}
